import { IconPrinter } from "@tabler/icons-react"
import { DateTime } from "../../../../../@client/System"
import { ResponsiveActionIconButton } from "./responsive-action-icon-button"

type Props = {
  departmentId: number
  start: DateTime
  end: DateTime
  filteredWorkareaIds: number[] | null | undefined
}

function toQueryParameter(filteredWorkareaIds: number[] | null | undefined) {
  return filteredWorkareaIds === null ||
    filteredWorkareaIds === undefined ||
    filteredWorkareaIds.length === 0
    ? ""
    : "" + filteredWorkareaIds.map((v) => `&workareaIds=${v}`).join("")
}

export function PrintCastButton(props: Props) {
  const workareasParameter = toQueryParameter(props.filteredWorkareaIds)
  const url = `/api/orchestra/GetPrintCast?departmentId=${props.departmentId}&start=${props.start}&end=${props.end}${workareasParameter}`

  return (
    <ResponsiveActionIconButton
      icon={<IconPrinter size={16} />}
      buttonProps={{
        size: "xs",
        variant: "default",
        children: "PDF",
        onClick: () => {
          window.open(url, "_blank")
        },
      }}
      actionIconProps={{
        variant: "default",
        onClick: () => {
          window.open(url, "_blank")
        },
      }}
    />
  )
}
